import { render, staticRenderFns } from "./QuotaCapacityModal.vue?vue&type=template&id=34ed7116&lang=pug&"
import script from "./QuotaCapacityModal.vue?vue&type=script&lang=js&"
export * from "./QuotaCapacityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports